import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleCheck,
  faEnvelope,
  faFolder,
  faHourglassHalf,
  faPen,
} from '@fortawesome/pro-duotone-svg-icons';
import { faTimesCircle, faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';

export type CodStatusTranscricao =
  | 'CRIADA'
  | 'CANCEL'
  | 'ENTREG'
  | 'ANALIS'
  | 'FINALI'
  | 'SOLINF'
  | 'PENENV'
  | 'POS-IA';

export type TranscricaoSituacaoVisual =
  | 'pendencia'
  | 'emAnalise'
  | 'finalizada'
  | 'cancelada'
  | 'entregue'
  | 'processando'
  | 'default';

export interface TranscricaoStatusConfig {
  label: string;
  visual: TranscricaoSituacaoVisual;
  icon: IconDefinition;
  exibirNaLista: boolean;
}

export const TRANSCRICAO_STATUS_MAP: Record<CodStatusTranscricao, TranscricaoStatusConfig> = {
  CRIADA: {
    label: 'Criada',
    visual: 'default',
    icon: faPen,
    exibirNaLista: false,
  },
  CANCEL: {
    label: 'Cancelada',
    visual: 'cancelada',
    icon: faTimesCircle,
    exibirNaLista: true,
  },
  ENTREG: {
    label: 'Entregue',
    visual: 'entregue',
    icon: faEnvelope,
    exibirNaLista: true,
  },
  ANALIS: {
    label: 'Em análise',
    visual: 'emAnalise',
    icon: faFolder,
    exibirNaLista: true,
  },
  FINALI: {
    label: 'Finalizada',
    visual: 'finalizada',
    icon: faCircleCheck,
    exibirNaLista: true,
  },
  SOLINF: {
    label: 'Pendência',
    visual: 'pendencia',
    icon: faTriangleExclamation,
    exibirNaLista: true,
  },
  PENENV: {
    label: 'Pendência enviada',
    visual: 'processando',
    icon: faHourglassHalf,
    exibirNaLista: false,
  },
  'POS-IA': {
    label: 'Pós-IA',
    visual: 'processando',
    icon: faHourglassHalf,
    exibirNaLista: false,
  },
};

const STATUS_EXIBICAO_CLIENTE_DE_PARA: Partial<Record<CodStatusTranscricao, CodStatusTranscricao>> = {
  ENTREG: 'ANALIS',
};

const FALLBACK_STATUS_CONFIG: TranscricaoStatusConfig = {
  label: '—',
  visual: 'default',
  icon: faPen,
  exibirNaLista: true,
};

export const normalizeCodStatusTranscricao = (
  cod?: string | null,
): CodStatusTranscricao | null => {
  if (!cod?.trim()) return null;

  const normalized = cod.trim().toUpperCase();
  if (normalized in TRANSCRICAO_STATUS_MAP) {
    return normalized as CodStatusTranscricao;
  }

  return null;
};

/** Status exibido ao beneficiário (lista, badge). Espelha o resolver do HistoricoStatus. */
export const resolveCodStatusParaExibicaoCliente = (
  cod?: string | null,
): CodStatusTranscricao | null => {
  const normalized = normalizeCodStatusTranscricao(cod);
  if (!normalized) return null;

  return STATUS_EXIBICAO_CLIENTE_DE_PARA[normalized] ?? normalized;
};

export const getTranscricaoStatusConfig = (
  cod?: string | null,
  descr?: string | null,
): TranscricaoStatusConfig => {
  const codNormalizado = resolveCodStatusParaExibicaoCliente(cod);
  if (codNormalizado) {
    return TRANSCRICAO_STATUS_MAP[codNormalizado];
  }

  return {
    ...FALLBACK_STATUS_CONFIG,
    label: descr?.trim() || FALLBACK_STATUS_CONFIG.label,
  };
};

export const deveExibirTranscricaoNaLista = (cod?: string | null): boolean =>
  getTranscricaoStatusConfig(cod).exibirNaLista;
